module.exports = __webpack_public_path__ + "static/media/LoyalityProgramsCards5.fc93a468.png";